import { render, staticRenderFns } from "./WebAdmin.vue?vue&type=template&id=0a1a25d6&"
import script from "./WebAdmin.vue?vue&type=script&lang=js&"
export * from "./WebAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports